import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-80" data-mp="1o3x3nprb6w3l">
      <div className="bg-brand-cream border-2 border-brand-gold/40 p-4 rounded-lg text-center shadow-md" data-id="element-81" data-mp="1o33y2s436cn1">
        <p className="text-xs font-button font-bold text-brand-rose uppercase tracking-widest mb-2" data-id="element-82" data-mp="222n0d4a7utrf">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="w-12 h-12 mx-auto bg-brand-rose/10 rounded-full flex items-center justify-center mb-2" data-id="element-83" data-mp="19dzdj49tjwbr">
          <ShieldCheck className="w-6 h-6 text-brand-rose" data-id="element-84" data-mp="14gph34o0ikef" />
        </div>
        <h3 className="text-xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-85" data-mp="1j52du3uxc79z">
          🛡️ 7-Day Total Guarantee
        </h3>
        <p className="text-sm font-subheading font-bold text-brand-taupe mb-2 uppercase tracking-wide" data-id="element-86" data-mp="1ecizv5sbra4n">
          Your money is 100% protected
        </p>
        <p className="text-xs sm:text-sm text-brand-taupe font-medium leading-tight" data-id="element-87" data-mp="lpy9a7job225">
          You have 7 full days to explore the 6 guides, apply the class
          structures in your studio, and evaluate the results with your real
          students. If you are not fully satisfied, we will refund 100% of your
          money. Zero risk for you, total commitment from us.
        </p>
      </div>
    </section>;
}